import { useCallback, useEffect, useState } from "react";

// Sidebar open/closed, remembered across refreshes. The width is published as
// the --sidebar-width CSS variable on <html>, so everything laid out against
// the sidebar (section tab bars, the logs filter drawer) follows it.
const STORAGE_KEY = "dashboard.sidebarCollapsed";
export const SIDEBAR_WIDTH = { expanded: 261, collapsed: 72 };

function publishWidth(collapsed) {
  document.documentElement.style.setProperty(
    "--sidebar-width",
    `${collapsed ? SIDEBAR_WIDTH.collapsed : SIDEBAR_WIDTH.expanded}px`,
  );
}

// Read the saved choice and publish its width before the first render, so a
// refresh opens in that state instead of animating from open to closed.
function readStored() {
  let collapsed = false;
  try {
    collapsed = localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    // storage blocked (private mode etc.) — default to open
  }
  publishWidth(collapsed);
  return collapsed;
}

const useSidebarCollapsed = () => {
  const [collapsed, setCollapsed] = useState(readStored);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, collapsed ? "1" : "0");
    } catch {
      // not persisted this time; the toggle still works
    }
    publishWidth(collapsed);
  }, [collapsed]);

  const toggle = useCallback(() => setCollapsed((value) => !value), []);

  return [collapsed, toggle];
};

export default useSidebarCollapsed;
